import { render, staticRenderFns } from "./thirdPage.vue?vue&type=template&id=ef2a781a&scoped=true"
import script from "./thirdPage.vue?vue&type=script&lang=js"
export * from "./thirdPage.vue?vue&type=script&lang=js"
import style0 from "./thirdPage.vue?vue&type=style&index=0&id=ef2a781a&prod&scoped=true&lang=css"
import style1 from "./thirdPage.vue?vue&type=style&index=1&id=ef2a781a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2a781a",
  null
  
)

export default component.exports